
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M6 11a1 1 0 100-2 1 1 0 000 2zM6 8a1 1 0 01-1-1V2a1 1 0 012 0v5a1 1 0 01-1 1z"}})])])
          )
        }
      }
    